import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery } from 'helpers/api';

export const linkedinApi = createApi({
  reducerPath: 'linkedinApi',
  baseQuery: createBaseQuery('linkedin', { timeout: 0 }),
  endpoints: builder => ({
    getLinkedinProfile: builder.query({
      query: code => `?code=${code}`,
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const { useLazyGetLinkedinProfileQuery } = linkedinApi;
